module.exports = __webpack_public_path__ + "img/深圳华侨城坪山之眼.b0c7f491.png";